import RESTSerializer from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import { underscore } from 'frontend-utils/utils/convert-case';

export default class ApplicationSerializer extends RESTSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  extractMeta(store: Store, modelClass: ModelSchema, payload: object) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    let meta = super.extractMeta(store, modelClass, payload);
    if (!meta) {
      meta = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    meta.payload = payload;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return meta;
  }

  /*
    Responsible for translating api_properties to modelProperties
   */
  keyForAttribute(key: string): string {
    return underscore(key);
  }

  keyForLink(key: string): string {
    return underscore(key);
  }

  keyForRelationship(key: string): string {
    return underscore(key);
  }
}
